// Client names are stored inconsistently: mostly "Last, First", some
// "First Last". These helpers are the single source of truth for showing
// and searching them. Always display via displayClientName so "Smith,
// Ellie" reads (and sorts) as "Ellie Smith".

export function displayClientName(rawName) {
  if (!rawName) return '';
  const name = String(rawName).trim();
  if (!name.includes(',')) return name;
  const parts = name.split(',').map((s) => s.trim()).filter(Boolean);
  if (parts.length < 2) return parts[0] || '';
  const [last, ...rest] = parts;
  return `${rest.join(' ')} ${last}`;
}

// True when every whitespace-separated word of `query` appears in either
// the stored or the display form of the name (case-insensitive).
export function clientNameMatches(rawName, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  const raw = (rawName || '').toLowerCase();
  const display = displayClientName(rawName).toLowerCase();
  return q.split(/\s+/).every((word) => raw.includes(word) || display.includes(word));
}
